var map = {
	"./amount.svg": "a2c3",
	"./applicant.svg": "25c8",
	"./article.svg": "8fe3",
	"./as-top.svg": "a7b8",
	"./base.svg": "affa",
	"./building.svg": "d439",
	"./business.svg": "55f6",
	"./calendar.svg": "76b2",
	"./community.svg": "9286",
	"./country.svg": "1908",
	"./dashboard.svg": "6f9f",
	"./dashboard2.svg": "3afa",
	"./default-avatar.svg": "7fab",
	"./delete.svg": "571d",
	"./dict.svg": "1fe5",
	"./dollar.svg": "c667",
	"./dot.svg": "58b4",
	"./edit.svg": "2dd2",
	"./enterprise.svg": "f0ee",
	"./exchange.svg": "346f",
	"./fans.svg": "777d",
	"./feedback.svg": "784f",
	"./feedbackActive.svg": "31b1",
	"./friends.svg": "d07f",
	"./help.svg": "e336",
	"./home.svg": "f2a5",
	"./jump.svg": "1f77",
	"./loading.svg": "e96b",
	"./lock.svg": "3b18",
	"./log-out.svg": "d3b2",
	"./material.svg": "bd14",
	"./operation.svg": "bdaa",
	"./phone.svg": "1f9a",
	"./plan.svg": "ec87",
	"./planAndServices.svg": "1706",
	"./push.svg": "a05d",
	"./refund.svg": "7f9f",
	"./setting.svg": "614f",
	"./setting2.svg": "af809",
	"./trend.svg": "31fc",
	"./upload.svg": "cdcb",
	"./vip.svg": "e1bd",
	"./wechat.svg": "2ecd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";